import axiosV1 from "@/plugins/axios/configV1";

const cmpBaseURL = "product-registrations/cmp";
const noncmpBaseURL = "product-registrations/non-cmp";

export default {
    getCmpRegistration(id = null) {
        return axiosV1.get(`${cmpBaseURL}/view/${id}`);
    },
    getCmpRegistrations(params) {
        return axiosV1.get(`${cmpBaseURL}`, { params });
    },
    exportCmpRegistrations(params) {
        return axiosV1.get(`${cmpBaseURL}/export`, { params });
    },
    requestCmpDocument(...payload) {
        return axiosV1.post(`${cmpBaseURL}/request/document`, ...payload);
    },
    approveCmpRegistration(id = null, ...payload) {
        return axiosV1.post(`${cmpBaseURL}/approve/${id}`, ...payload);
    },
    rejectCmpRegistration(id = null, ...payload) {
        return axiosV1.post(`${cmpBaseURL}/reject/${id}`, ...payload);
    },
    rejectStudentPromo(id = null, ...payload) {
        return axiosV1.post(`${cmpBaseURL}/reject/promo/${id}`, ...payload);
    },
    validateStudentPromo(id = null, ...payload) {
        return axiosV1.post(`${cmpBaseURL}/validate/promo/${id}`, ...payload);
    },
    getPromoDuplicates(id = null) {
        return axiosV1.get(`${cmpBaseURL}/check/promo/duplicates/${id}`);
    },
    getCmpProducts() {
        return axiosV1.get(`${cmpBaseURL}/get/products`);
    },
    getActivityLogs(id = null) {
        return axiosV1.get(`/activity-logs/target/${id}`);
    },
    updateCmpProductInfo(id = null, ...payload) {
        return axiosV1.post(
            `${cmpBaseURL}/edit/product-info/${id}`,
            ...payload
        );
    },
    updateCmpPurchaseInfo(id = null, ...payload) {
        return axiosV1.post(
            `${cmpBaseURL}/edit/purchase-info/${id}`,
            ...payload
        );
    },
    getCmpStores(params) {
        return axiosV1.get(`${cmpBaseURL}/get/stores`, { params });
    },
    requestCmpApproval(...payload) {
        return axiosV1.post(`${cmpBaseURL}/request/approval`, ...payload);
    },
    validateCmpRegistration(id = null) {
        return axiosV1.post(`${cmpBaseURL}/validate/${id}`);
    },
    importCmpRegistration(file = null) {
        let formData = new FormData();
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`${cmpBaseURL}/import`, formData);
    },
    updateItemStatus(id = null) {
        // return axiosV1.post(`${cmpBaseURL}/validate/${id}`);
		// TODO: to be change when BE is ready
        return null;
    },
    // Approve all
    // approveAll() {
    //     return axiosV1.get(`${cmpBaseURL}/approve/all`);
    // },
    approveAll(ids = null) {
        return axiosV1.post(`${cmpBaseURL}/approve-all`, ids);
    },
    getCmpCompletion() {
        return axiosV1.get(`${cmpBaseURL}/notify/approve-all/completion`);
    },
    getCmpProcessing() {
        return axiosV1.get(`${cmpBaseURL}/check/import/processing`); 
    },
    rejectAll(ids = null) {
        return axiosV1.post(`${cmpBaseURL}/reject/all`, ids);
    },

    // Non CMP Registrations
    getNoncmpRegistration(id = null) {
        return axiosV1.get(`${noncmpBaseURL}/view/${id}`);
    },
    getNoncmpRegistrations(params) {
        return axiosV1.get(`${noncmpBaseURL}`, { params });
    },
    deleteNoncmpRegistration(id = null) {
        return axiosV1.post(`${noncmpBaseURL}/delete/${id}`);
    },
    deleteNoncmpRegistrations(ids = null) {
        return axiosV1.post(`${noncmpBaseURL}/bulk/delete`, ids);
    },
    exportNoncmpRegistrations(params) {
        return axiosV1.get(`${noncmpBaseURL}/export`, { params });
    },
    markAsNoncmp(id = null, ...payload) {
        return axiosV1.post(`${noncmpBaseURL}/mark-as-cmp/${id}`, ...payload);
    },
    rejectNonCmpRegistration(id = null, ...payload) {
        return axiosV1.post(`${cmpBaseURL}/reject/${id}`, ...payload);
    },
    getNoncmpModels() {
        return axiosV1.get(`${noncmpBaseURL}/fetch/models`);
    },
    updateNoncmpModel(id = null, ...payload) {
        return axiosV1.post(`${noncmpBaseURL}/update/model/${id}`, ...payload);
    },
    validateNoncmpSerialNumber(...payload) {
        return axiosV1.post(
            `${noncmpBaseURL}/validate/serial-number`,
            ...payload
        );
    },
    updateNoncmpSerialNumber(id = null, ...payload) {
        return axiosV1.post(
            `${noncmpBaseURL}/update/serial-number/${id}`,
            ...payload
        );
    },
    updateNoncmpPurchaseDate(id = null, ...payload) {
        return axiosV1.post(
            `${noncmpBaseURL}/update/purchase-date/${id}`,
            ...payload
        );
    },
    getNoncmpStores(params) {
        return axiosV1.get(`${noncmpBaseURL}/fetch/stores`, { params });
    },
    updateNoncmpStore(id = null, ...payload) {
        return axiosV1.post(`${noncmpBaseURL}/update/store/${id}`, ...payload);
    },
    updateNoncmpAmount(id = null, ...payload) {
        return axiosV1.post(`${noncmpBaseURL}/update/amount/${id}`, ...payload);
    },

    // Add Product Registration
    addRegistration(payload) {
        let formData = new FormData();
        for (const key in payload) {
            formData.append(key, payload[key] ? payload[key] : "");
        }
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post("product-registrations/cmp/store", formData);
    },
    verifyPinCode(pin = null) {
        return axiosV1.get(`product-registrations/cmp/verify/pin?pin=${pin}`);
    },
    verifySerialNumber(serial_no = null) {
        return axiosV1.get(
            `product-registrations/cmp/verify/serial-number?serial_no=${serial_no}`
        );
    },
    getRequestNumber() {
        return axiosV1.get("product-registrations/cmp/generate/next/id");
    },
    getCustomers() {
        return axiosV1.get("fetch/customers");
    },
    getProduct(...payload) {
        return axiosV1.post("product-registrations/fetch/product", ...payload);
    },
    getCategories() {
        return axiosV1.get("product-registrations/cmp/fetch/categories");
    },
    getModels(params) {
        return axiosV1.get("product-registrations/cmp/fetch/models", {
            params,
        });
    },
    getStores() {
        return axiosV1.get("product-registrations/cmp/fetch/stores");
    },
};
